module.exports = __webpack_public_path__ + "static/media/youtube-logo-dark.9f5658e7.png";